import { DateTime } from "luxon";

import { GetCurrentStep, Step } from "../../../types/Step";
import IUserEvent, { UserEventType } from "./IUserEvent";

class StepArrivalUserEvent implements IUserEvent<Step> {
  readonly type = UserEventType.StepArrival;
  readonly timestamp: DateTime;
  readonly value: Step;

  constructor(routeUri: string) {
    this.timestamp = DateTime.now();
    const step = GetCurrentStep(routeUri);
    if (step) this.value = step;
    else throw new Error(`Unable to create StepArrivalUserEvent: routeUri ${routeUri} did not match any known steps.`);
  }
}

export default StepArrivalUserEvent;
